import React from 'react';

export const CURRENT_EVENT_YEAR = new Date().getFullYear();
export const MIN_EVENT_YEAR = 2025;

export const normalizeEventYear = (value, fallback = CURRENT_EVENT_YEAR) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed >= MIN_EVENT_YEAR && parsed <= 2100
    ? parsed
    : Math.max(MIN_EVENT_YEAR, fallback);
};

export const buildEventYearOptions = (selectedYear, currentYear = CURRENT_EVENT_YEAR) => {
  const selected = normalizeEventYear(selectedYear, currentYear);
  const firstYear = Math.max(MIN_EVENT_YEAR, currentYear + 1, selected);
  return Array.from(
    { length: firstYear - MIN_EVENT_YEAR + 1 },
    (_, index) => firstYear - index,
  );
};

// With allowAll, an empty value means "All years".
const YearSelector = ({ id, value, onChange, label = 'Event year', className = '', allowAll = false }) => (
  <div className={`form-group year-scope-filter ${className}`.trim()}>
    <label htmlFor={id}>{label}</label>
    <select
      id={id}
      value={allowAll && !value ? '' : normalizeEventYear(value)}
      onChange={(event) => onChange(
        allowAll && !event.target.value ? '' : normalizeEventYear(event.target.value),
      )}
    >
      {allowAll && <option value="">All</option>}
      {buildEventYearOptions(value).map((year) => (
        <option key={year} value={year}>{year}</option>
      ))}
    </select>
  </div>
);

export default YearSelector;
